/* ============================================================================
   BlueBox — Registro: código de país del teléfono

   Dos cosas hace este archivo.

   1) CONCATENA el código al número. La base no tiene columna para el código de
      país: el teléfono es un solo campo. Así que se guarda `+506 88887777` en
      el mismo campo `Phone` de siempre.

      | Elemento     | name    | Para qué |
      |--------------|---------|----------|
      | `PhoneCode`  | ninguno | lista de países (select real, oculto acá) |
      | `PhoneLocal` | ninguno | número visible, sin el código |
      | `Phone`      | Phone   | oculto; es el único que se postea |

      Los visibles NO llevan `name`: si lo llevaran, el formulario mandaría el
      teléfono dos o tres veces y el enlazador del backend armaría un valor con
      comas. El oculto conserva el nombre exacto que espera `ClientAccount`, así
      que del lado del servidor nada cambia.

      La sincronización ocurre en cada cambio y NO al enviar, por una razón
      concreta: register.js envía con `form.submit()` nativo dentro del
      submitHandler del validador, y esa llamada no dispara el evento submit. Un
      listener de submit acá nunca correría y el teléfono se guardaría sin
      código.

   2) CONVIERTE el `<select>` en un selector con bandera, código ISO y buscador.
      Un `<select>` nativo no puede llevar bandera ni filtrarse, y con 81 países
      obliga a recorrer la lista entera.

      Es mejora progresiva: la lista vive en el marcado como un `<select>` que
      funciona solo. Este guion lo esconde y arma el selector encima; si el
      guion no corre, queda el select nativo y el registro se completa igual.

   Sobre las banderas: se dibujan con los caracteres de bandera que se forman a
   partir del código ISO, no con imágenes, así no hay 81 archivos que servir.
   En Windows el sistema no trae esas banderas y en su lugar muestra las dos
   letras del país — por eso el código ISO va SIEMPRE escrito al lado, y no
   solo la bandera: ahí donde no se dibuja, la lista sigue siendo legible.

   Formato guardado: `+506 88887777`. El código separado del número por un
   espacio, y el número sin espacios internos. Con espacio porque ese valor lo
   lee gente en el sistema de bodega; cualquier uso automático (wa.me, tel:)
   descarta lo que no sea dígito de todas formas.

   Los clientes que ya existen tienen el teléfono sin código. Esa base no se
   toca: esto aplica a los registros nuevos.
   ========================================================================== */

(function () {
    'use strict';

    var selCodigo = document.getElementById('PhoneCode');
    var campoLocal = document.getElementById('PhoneLocal');
    var campoOculto = document.getElementById('Phone');

    if (!selCodigo || !campoLocal || !campoOculto) { return; }

    /* ---------------------------------------------------------------- utilería */

    function soloDigitos(valor) {
        return (valor || '').replace(/\D/g, '');
    }

    /* Para que "peru" encuentre a "Perú" y "espana" a "España". */
    function plano(texto) {
        return (texto || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    function bandera(iso) {
        if (!iso || iso.length !== 2) { return ''; }
        var base = 0x1F1E6;
        return String.fromCodePoint(
            base + iso.charCodeAt(0) - 65,
            base + iso.charCodeAt(1) - 65
        );
    }

    /* ------------------------------------------------- el valor que se postea */

    function sincronizar() {
        var digitos = soloDigitos(campoLocal.value);
        campoOculto.value = digitos ? selCodigo.value + ' ' + digitos : '';
    }

    /* El número local se queda solo con dígitos. Acá se corrige en silencio en
       vez de avisar: en un teléfono la gente escribe espacios y guiones por
       costumbre —"8888 7777"— y eso no es un error que valga interrumpir, a
       diferencia de la cédula, que es la llave con la que después entra. */
    campoLocal.addEventListener('input', function () {
        var limpio = soloDigitos(campoLocal.value);
        if (campoLocal.value !== limpio) {
            var posicion = campoLocal.selectionStart - (campoLocal.value.length - limpio.length);
            campoLocal.value = limpio;
            try { campoLocal.setSelectionRange(posicion, posicion); } catch (e) { /* no crítico */ }
        }
        sincronizar();
    });
    campoLocal.addEventListener('blur', sincronizar);
    selCodigo.addEventListener('change', sincronizar);

    /* ------------------------------------------------------------ el selector */

    var paises = Array.prototype.map.call(selCodigo.options, function (opcion, indice) {
        var iso = opcion.getAttribute('data-iso') || '';
        return {
            indice: indice,
            iso: iso,
            dial: opcion.value,
            nombre: opcion.textContent.trim(),
            bandera: bandera(iso),
            buscable: plano(opcion.textContent + ' ' + iso + ' ' + opcion.value)
        };
    });

    if (!paises.length) { return; }

    var contenedor = document.createElement('div');
    contenedor.className = 'bb-combo';

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'bb-input bb-combo__boton';
    boton.id = 'PhoneCode-boton';
    boton.setAttribute('aria-haspopup', 'listbox');
    boton.setAttribute('aria-expanded', 'false');
    boton.setAttribute('aria-label', 'Código de país');

    var panel = document.createElement('div');
    panel.className = 'bb-combo__panel';
    panel.hidden = true;

    var buscador = document.createElement('input');
    buscador.type = 'text';
    buscador.className = 'bb-input bb-combo__buscador';
    buscador.placeholder = 'Buscá el país o el código';
    buscador.setAttribute('aria-label', 'Buscá el país o el código');
    buscador.autocomplete = 'off';

    var lista = document.createElement('ul');
    lista.className = 'bb-combo__lista';
    lista.setAttribute('role', 'listbox');
    lista.setAttribute('aria-label', 'Código de país');

    var vacio = document.createElement('p');
    vacio.className = 'bb-combo__vacio';
    vacio.textContent = 'Ningún país coincide con eso.';
    vacio.hidden = true;

    panel.appendChild(buscador);
    panel.appendChild(lista);
    panel.appendChild(vacio);
    contenedor.appendChild(boton);
    contenedor.appendChild(panel);

    selCodigo.parentNode.insertBefore(contenedor, selCodigo);
    /* El select real se queda en el documento —es el que guarda el valor— pero
       fuera de la vista y fuera del recorrido con tabulador, para que no se
       anuncie dos veces el mismo control. */
    selCodigo.classList.add('bb-combo__nativo');
    selCodigo.setAttribute('tabindex', '-1');
    selCodigo.setAttribute('aria-hidden', 'true');

    var opciones = paises.map(function (pais) {
        var li = document.createElement('li');
        li.className = 'bb-combo__opcion';
        li.id = 'PhoneCode-op-' + pais.iso;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.dataset.indice = String(pais.indice);

        var flag = document.createElement('span');
        flag.className = 'bb-combo__bandera';
        flag.setAttribute('aria-hidden', 'true');
        flag.textContent = pais.bandera;

        var nombre = document.createElement('span');
        nombre.className = 'bb-combo__nombre';
        nombre.textContent = pais.nombre;

        var iso = document.createElement('span');
        iso.className = 'bb-combo__iso';
        iso.textContent = pais.iso;

        var dial = document.createElement('span');
        dial.className = 'bb-combo__dial';
        dial.textContent = pais.dial;

        li.appendChild(flag);
        li.appendChild(nombre);
        li.appendChild(iso);
        li.appendChild(dial);
        lista.appendChild(li);
        return li;
    });

    var resaltada = -1;

    function pintarBoton() {
        var pais = paises[selCodigo.selectedIndex] || paises[0];
        boton.textContent = '';

        var flag = document.createElement('span');
        flag.className = 'bb-combo__bandera';
        flag.setAttribute('aria-hidden', 'true');
        flag.textContent = pais.bandera;

        var iso = document.createElement('span');
        iso.className = 'bb-combo__iso';
        iso.textContent = pais.iso;

        var dial = document.createElement('span');
        dial.className = 'bb-combo__dial';
        dial.textContent = pais.dial;

        var flecha = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        flecha.setAttribute('class', 'bb-combo__flecha');
        flecha.setAttribute('viewBox', '0 0 24 24');
        flecha.setAttribute('aria-hidden', 'true');
        var trazo = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        trazo.setAttribute('d', 'M6 9l6 6 6-6');
        trazo.setAttribute('fill', 'none');
        trazo.setAttribute('stroke', 'currentColor');
        trazo.setAttribute('stroke-width', '2');
        trazo.setAttribute('stroke-linecap', 'round');
        trazo.setAttribute('stroke-linejoin', 'round');
        flecha.appendChild(trazo);

        boton.appendChild(flag);
        boton.appendChild(iso);
        boton.appendChild(dial);
        boton.appendChild(flecha);

        opciones.forEach(function (li, i) {
            li.setAttribute('aria-selected', i === selCodigo.selectedIndex ? 'true' : 'false');
        });
    }

    function visibles() {
        return opciones.filter(function (li) { return !li.hidden; });
    }

    function resaltar(li) {
        opciones.forEach(function (otra) { otra.classList.remove('es-resaltada'); });
        if (!li) {
            resaltada = -1;
            lista.removeAttribute('aria-activedescendant');
            return;
        }
        li.classList.add('es-resaltada');
        resaltada = opciones.indexOf(li);
        lista.setAttribute('aria-activedescendant', li.id);
        var arriba = li.offsetTop;
        var abajo = arriba + li.offsetHeight;
        if (arriba < lista.scrollTop) { lista.scrollTop = arriba; }
        else if (abajo > lista.scrollTop + lista.clientHeight) { lista.scrollTop = abajo - lista.clientHeight; }
    }

    function mover(paso) {
        var vista = visibles();
        if (!vista.length) { return; }
        var actual = vista.indexOf(opciones[resaltada]);
        var siguiente = actual === -1
            ? (paso > 0 ? 0 : vista.length - 1)
            : Math.min(Math.max(actual + paso, 0), vista.length - 1);
        resaltar(vista[siguiente]);
    }

    function filtrar() {
        var busqueda = plano(buscador.value.trim());
        var cuantas = 0;
        paises.forEach(function (pais, i) {
            var calza = !busqueda || pais.buscable.indexOf(busqueda) !== -1;
            opciones[i].hidden = !calza;
            if (calza) { cuantas++; }
        });
        vacio.hidden = cuantas > 0;
        var vista = visibles();
        resaltar(vista.length ? vista[0] : null);
    }

    function abrir() {
        if (!panel.hidden) { return; }
        panel.hidden = false;
        boton.setAttribute('aria-expanded', 'true');
        buscador.value = '';
        filtrar();
        resaltar(opciones[selCodigo.selectedIndex]);
        buscador.focus();
    }

    function cerrar(devolverFoco) {
        if (panel.hidden) { return; }
        panel.hidden = true;
        boton.setAttribute('aria-expanded', 'false');
        if (devolverFoco) { boton.focus(); }
    }

    function elegir(li) {
        if (!li) { return; }
        selCodigo.selectedIndex = parseInt(li.dataset.indice, 10);
        selCodigo.dispatchEvent(new Event('change', { bubbles: true }));
        pintarBoton();
        cerrar(true);
    }

    boton.addEventListener('click', function () {
        if (panel.hidden) { abrir(); } else { cerrar(true); }
    });

    boton.addEventListener('keydown', function (evento) {
        if (evento.key === 'ArrowDown' || evento.key === 'ArrowUp') {
            evento.preventDefault();
            abrir();
        }
    });

    buscador.addEventListener('input', filtrar);

    buscador.addEventListener('keydown', function (evento) {
        if (evento.key === 'ArrowDown') { evento.preventDefault(); mover(1); }
        else if (evento.key === 'ArrowUp') { evento.preventDefault(); mover(-1); }
        else if (evento.key === 'Home') { evento.preventDefault(); resaltar(visibles()[0]); }
        else if (evento.key === 'End') { evento.preventDefault(); var v = visibles(); resaltar(v[v.length - 1]); }
        else if (evento.key === 'Enter') { evento.preventDefault(); elegir(opciones[resaltada]); }
        else if (evento.key === 'Escape') { evento.preventDefault(); cerrar(true); }
        else if (evento.key === 'Tab') { cerrar(false); }
    });

    lista.addEventListener('click', function (evento) {
        var li = evento.target.closest('.bb-combo__opcion');
        if (li) { elegir(li); }
    });

    lista.addEventListener('mousemove', function (evento) {
        var li = evento.target.closest('.bb-combo__opcion');
        if (li && !li.classList.contains('es-resaltada')) { resaltar(li); }
    });

    document.addEventListener('click', function (evento) {
        if (!contenedor.contains(evento.target)) { cerrar(false); }
    });

    pintarBoton();
    sincronizar();
})();
